import { createAsyncThunk } from "@reduxjs/toolkit";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import { axios } from "../../common";
import moment from "moment";

import OptionHeaders from "../options";
const { token, baseUrl, employeOid } = OptionHeaders();
const TRANSACTION_ADJUSTMENT_SHOW = "transaction/showTransactionAdjustment";
const TRANSACTION_ADJUSTMENT_PUT = "transaction/putTransactionAdjustment";
const TRANSACTION_ADJUSTMENT_APPROVAL_SHOW =
  "transaction/showTransactionAdjustmentApproval";
const TRANSACTION_ADJUSTMENT_DATA_SHOW =
  "transaction/showTransactionAdjustmentData";

export const showTransactionAdjustment = createAsyncThunk(
  TRANSACTION_ADJUSTMENT_SHOW,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.post("TransactionAdjustment", payload);

      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const putTransactionAdjustment = createAsyncThunk(
  TRANSACTION_ADJUSTMENT_PUT,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.post(`AdjustTransaction`, payload);

      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const showTransactionAdjustmentData = createAsyncThunk(
  TRANSACTION_ADJUSTMENT_DATA_SHOW,
  async (payload, thunkAPI) => {
    const FromDate = moment(new Date(payload.FromDate)).format();
    const ToDate = moment(new Date(payload.ToDate)).format();
    try {
      const TRANSACTION = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}TransactionAdjustmentData`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
        expand: ["Period"],
        filter: [
          "Employee/Oid eq " +
            employeOid +
            "" +
            " and FromDate ge " +
            FromDate +
            "" +
            " and ToDate le " +
            ToDate +
            "" +
            " and RequestStatus in [" +
            payload.Status.map((status) => `'${status.toString(",")}'`) +
            "]",
        ],
      });
      return TRANSACTION;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const getTransactionApproval = createAsyncThunk(
  TRANSACTION_ADJUSTMENT_APPROVAL_SHOW,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.post(
        "TransactionAdjustmentForApproval",
        payload,
        {
          headers: {
            MappedState: 1,
          },
        }
      );
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
